module.exports = __webpack_public_path__ + "static/media/design.6744e2b6.png";